import { SegmentedBars } from '@mentimeter/visualizations-react';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { SegmentedChoicesVisualizationProps } from '../types';
import { getColors } from '../../../shared/utils/getColors';

export const SegmentedBarsDataHandler = ({
  showCorrect,
  results,
  choices,
  shouldShowPercent,
  shouldHideResults,
  shouldAnimate,
  segmentation,
  renderChoiceVisualization,
  renderChoiceLabel,
}: SegmentedChoicesVisualizationProps) => {
  const {
    theme: {
      colors: { neutralWeak },
      visualizationColors: { fillColors, textColor, backgroundColor },
      fonts: { body },
    },
  } = useRagnar();

  // we need bigger set of colors for segmentation and we can't repeat them, so we need to expand with more variations
  const { barColors: segmentColors } = getColors(fillColors, backgroundColor);

  const { results: currentResults, respondents } = results;

  const segmentedData = currentResults.map((result) => ({
    id: result.id,
    scores: result.score,
  }));

  const visualizationShouldShowPercent =
    // yes it is the opposite and that's for the historical reasons
    // the property coming from BE refers to the percentage in each segment, and the bar score behaves the opposite
    // for example: `true` from BE means "show % in each segment" and show the exact score value above each bar
    // the property that the visualization expects (same as Bar and Pie visualizations) refers to the percentage of bar score
    // so when we want to show it, we need to know what it is percentage of
    shouldShowPercent ? false : { percentOf: respondents };

  if (segmentation.isSegmented) {
    return (
      <Box px="space2" width="100%" height="100%">
        <FullSizeContainer>
          {(width, height) => {
            return (
              <SegmentedBars
                colors={segmentColors as [string, ...[string]]}
                textColor={textColor}
                placeHolderColor={neutralWeak}
                data={segmentedData}
                staticOptions={choices}
                segments={segmentation.segments}
                sourceQuestionTitle={segmentation.segmentedQuestionTitle}
                width={width}
                height={height}
                shouldShowScorePercentage={visualizationShouldShowPercent}
                shouldShowCorrect={showCorrect}
                isScoreHidden={shouldHideResults}
                disableAnimations={!shouldAnimate}
                fontFamily={body}
                renderChoiceLabel={renderChoiceLabel}
                renderChoiceVisualization={renderChoiceVisualization}
              />
            );
          }}
        </FullSizeContainer>
      </Box>
    );
  }
  return null;
};
